export default __webpack_public_path__ + "static/media/img-slider-ommerchant-3.74a1dba8.png";